import { useEffect, useState } from "react";
import Permission from "../../../../../common/components/auth/Permission";
import { GenericInfoField } from "../../../../../common/helpers/generic-info-field";
import "./index.scss";
import { maskCurrency } from "../../../../../common/helpers/mask.helpers";
import { usePreparationReportsDashboardContext } from "./Preparation.context";
import {
  ItensWorkOrder,
  WORK_ORDER_TYPE,
} from "../../../../../types/workorder.types";

export function PreparationsReportsDashboard() {
  const { workOrder } = usePreparationReportsDashboardContext();
  const [itens, setItens] = useState<ItensWorkOrder[]>([]);

  useEffect(() => {
    setItens(workOrder.itens);
  }, [workOrder]);

  if (!workOrder) {
    return <div>Loading...</div>;
  }

  return (
    <div className="containerPreparationReports">
      <Permission permission="edit:inventory-pieces">
        {workOrder._id && (
          <section className="bg-gray/20 p-4 dark:text-black rounded-md mb-5">
            <h2 className="text-2xl font-semibold mb-4">
              Detalhes da{" "}
              {workOrder.type === WORK_ORDER_TYPE.PREPARATION
                ? "Preparação"
                : "Repreparação"}
            </h2>
            <h3 className="text-lg font-medium mb-2">Itens utilizados</h3>
            {itens && itens.length > 0 ? (
              <div className="grid gap-4">
                {itens.map((item, idx) => (
                  <article
                    key={item._id || `${item.name}-${idx}`}
                    className="bg-white/80 p-3 rounded shadow-sm"
                  >
                    <div className="grid grid-cols-3 gap-2">
                      <GenericInfoField
                        id={`name${item.name}`}
                        spanSize="col-span-1"
                        label="Descrição"
                        value={item.name}
                      />
                      <GenericInfoField
                        id={`price${item.name}`}
                        spanSize="col-span-1"
                        label="Preço"
                        value={maskCurrency(item.sellPrice)}
                      />
                      <GenericInfoField
                        id={`quantity${item.name}`}
                        spanSize="col-span-1"
                        label="Quantidade"
                        value={item.quantity}
                      />
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="text-gray-500 italic mb-4">
                Nenhum item cadastrado.
              </div>
            )}
            {workOrder.observation && (
              <div className="col-12 mt-6 text-center">
                <strong>OBSERVAÇÕES:</strong> {workOrder.observation}
              </div>
            )}
          </section>
        )}
      </Permission>
    </div>
  );
}
